import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialItemCategoriesByTrialId: ITrialItemCategoriesLoadByTrialIdActionCreator = (trialId) => {
        return {
            type: ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID,
            trialId
        }
    },
    LoadSuccess: ITrialItemCategoriesLoadByTrialIdSuccessActionCreator = (formData, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID_SUCCESS,
            formData,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialItemCategoriesLoadByTrialIdFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialItemCategoriesClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALITEMCATEGORIES_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialItemCategoriesFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALITEMCATEGORIES_FILTER,
            formFilter
        }
    };


export const
    ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID = "ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID",
    ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID_SUCCESS = "ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID_SUCCESS",
    ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID_FAILURE = "ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID_FAILURE",

    ACTION_TRIALITEMCATEGORIES_CLEAR = "ACTION_TRIALITEMCATEGORIES_CLEAR",

    ACTION_TRIALITEMCATEGORIES_FILTER = "ACTION_TRIALITEMCATEGORIES_FILTER";

export interface ITrialItemCategoriesLoadByTrialIdAction {
    type: "ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID";
    trialId?: number;
}

export interface ITrialItemCategoriesLoadByTrialIdActionCreator {
    (trialId?: number): ITrialItemCategoriesLoadByTrialIdAction;
}

export interface ITrialItemCategoriesLoadByTrialIdSuccessAction {
    type: "ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID_SUCCESS";
    formData: Dtos.TrialItemCategory[];
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialItemCategoriesLoadByTrialIdSuccessActionCreator {
    (
        formData: Dtos.TrialItemCategory[],
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialItemCategoriesLoadByTrialIdSuccessAction;
}

export interface ITrialItemCategoriesLoadByTrialIdFailureAction {
    type: "ACTION_TRIALITEMCATEGORIES_LOAD_BY_TRIALID_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialItemCategoriesLoadByTrialIdFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialItemCategoriesLoadByTrialIdFailureAction;
}

export interface ITrialItemCategoriesClearAction {
    type: "ACTION_TRIALITEMCATEGORIES_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialItemCategoriesClearActionCreator {
    (propertiesToClear?: string[]): ITrialItemCategoriesClearAction;
}

export interface ITrialItemCategoriesFilterActionCreator {
    (formFilter: IFormFilter): ITrialItemCategoriesFilterAction;
}

export interface ITrialItemCategoriesFilterAction {
    type: "ACTION_TRIALITEMCATEGORIES_FILTER";
    formFilter: IFormFilter;
}

export type TrialItemCategoryActions =
    ITrialItemCategoriesLoadByTrialIdAction |
    ITrialItemCategoriesLoadByTrialIdSuccessAction |
    ITrialItemCategoriesLoadByTrialIdFailureAction |
    ITrialItemCategoriesClearAction |
    ITrialItemCategoriesFilterAction;